module.exports = __webpack_public_path__ + "senior-dns.png?b06b801049c353d250f8d83bb953d497";


//////////////////
// WEBPACK FOOTER
// ./static/assets/senior-dns.png
// module id = 487
// module chunks = 0